import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { translations } from './LanguageSelector/translations';

interface ShippingErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  allowedCountries: string[];
}

const ShippingErrorModal: React.FC<ShippingErrorModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  allowedCountries 
}) => {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
      <div className="relative mx-auto p-6 border w-96 shadow-lg rounded-md bg-white">
        <div>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
            <button 
              onClick={onClose} 
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-600 leading-relaxed mb-3">{message}</p>
              
              {allowedCountries.length > 0 && (
                <div>
                  <p className="text-sm font-medium text-gray-700 mb-2">
                    {t.cart.availableCountries || 'Available countries for shipping:'}
                  </p>
                  <div className="bg-gray-50 p-3 rounded-md">
                    <ul className="text-sm text-gray-600 space-y-1">
                      {allowedCountries.map((country, index) => (
                        <li key={index} className="flex items-center">
                          <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          {country}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingErrorModal;
